import { useQuery } from "react-query";
import { getOfficeCount } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetOfficeCount = () => {
  return useQuery("OfficeCount", getOfficeCount, {
    refetchOnWindowFocus: false,
  });
};
